import {
    AppBar, Toolbar, Typography, Box, IconButton, MenuItem,
    Paper, Badge, Drawer, Divider, Switch, FormControlLabel
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from '@mui/icons-material/Menu';
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';

const Cateringsnavbars = () => {
    const navigate = useNavigate();
    const [showContainer, setShowContainer] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isOnline, setIsOnline] = useState(false); // ✅ state for toggle

    const isMobile = useMediaQuery('(max-width:600px)');
    // const [isOnline, setIsOnline] = useState(false);

    useEffect(() => {
        // Example: read saved status from localStorage
        const savedStatus = localStorage.getItem("isOnline");
        if (savedStatus !== null) {
            setIsOnline(savedStatus === "true"); // convert string to boolean
        }

        // If fetching from API instead:
        // fetchStatusFromAPI().then(status => setIsOnline(status));
    }, []);

    const handleLogout = async () => {
        try {
            const authToken = localStorage.getItem("authToken");

            // Call your backend logout API
            await axios.post(
                "https://backend.maamaas.com/food/api/auth/logout",
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            // console.log("✅ Logged out successfully from backend");

        } catch (error) {
            console.error("❌ Logout API failed:", error);
        } finally {
            // Clear local storage & update UI state regardless of API success
            localStorage.removeItem("authToken");
            localStorage.removeItem("vendorId");

            setShowContainer(false);
            setDrawerOpen(false);
            navigate("/");
        }
    };

    // ✅ Fetch cart data
    const fetchCartData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            let count = 0;

            if (Array.isArray(response.data.cartItems)) {
                // Filter only TABLE_DINE_IN orderType
                const dineInItems = response.data.cartItems.filter(
                    item => item.orderType === "DINE_IN"
                );
                count = dineInItems.length;
            } else if (typeof response.data.cartItemsCount === "number") {
                count = response.data.cartItemsCount;
            } else if (typeof response.data === "number") {
                count = response.data;
            }

            setCartCount(count);
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    // ✅ Fetch restaurant online/offline status
    const fetchVendorStatus = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // assuming API returns { online: true/false }
            if (response.data && typeof response.data.online === "boolean") {
                setIsOnline(response.data.online);
            }
        } catch (error) {
            // console.error("Error fetching vendor status:", error);
        }
    };

    // ✅ Update restaurant online/offline status
    const handleToggleStatus = async (event) => {
        const newStatus = event.target.checked;
        setIsOnline(newStatus);

        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;
        localStorage.setItem("isOnline", newStatus);
        try {
            const token = localStorage.getItem("authToken");
            await axios.put(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { online: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            // console.log("✅ Vendor status updated:", newStatus);
        } catch (error) {
            console.error("Error updating vendor status:", error);
        }
    };

    useEffect(() => {
        fetchCartData();
        fetchVendorStatus();
    }, []);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const DrawerContent = (
        <Box sx={{ width: 250, padding: 2 }} role="presentation">
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>MAAMAA'S</Typography>

            <Divider />

            {/* ✅ Restaurant Status Toggle */}

        </Box>
    );

    return (
        <>
            <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1300 }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* Left Side - Logo */}
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", color: "#fff", fontSize: "26px", cursor: "pointer" }}
                        onClick={() => navigate("/foodladingpage")}
                    >
                        MAAMAA'S
                    </Typography>

                    {/* Right Side */}
                    {isMobile ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>



                            <Link to="/foodcart">
                                <IconButton sx={{ color: "white" }}>
                                    <Badge
                                        badgeContent={cartCount}
                                        color="error"
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                backgroundColor: '#4e4d4b',
                                                color: 'white',
                                                borderRadius: '4px',
                                                padding: '0 6px',
                                                minWidth: '20px',
                                                height: '20px',
                                            }
                                        }}
                                    >
                                        <ShoppingCartIcon fontSize="large" />
                                    </Badge>
                                </IconButton>
                            </Link>

                            <IconButton onClick={() => setShowContainer(!showContainer)} sx={{ color: "white" }} fontSize="large">
                                <AccountCircleIcon />
                            </IconButton>


                        </Box>
                    ) : (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isOnline}
                                        onChange={handleToggleStatus}
                                        color="primary"
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#fff', // ✅ Green when ON
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#fff',
                                            },
                                            '& .MuiSwitch-switchBase': {
                                                color: '#fff', // ✅ Red when OFF
                                            },
                                            '& .MuiSwitch-track': {
                                                backgroundColor: '#fff',
                                            }
                                        }}
                                    />
                                }
                                label={isOnline ? "Open" : "Closed"}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                    // backgroundColor: "#f9f9f9",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    // boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    color: isOnline ? "#fff" : "#fff",
                                    marginTop: "3px"
                                }}
                            />

                            {/* <IconButton sx={{ color: "white" }}>
                <NotificationsIcon fontSize="large" />
              </IconButton> */}



                            <IconButton onClick={() => setShowContainer(!showContainer)} sx={{ color: "white" }}>
                                <AccountCircleIcon fontSize="large" />
                            </IconButton>
                        </Box>
                    )}
                </Toolbar>

                {/* Desktop Account Menu */}
                {showContainer && (
                    <Paper sx={{
                        position: "absolute", top: "60px", right: "10px",
                        width: "120px", backgroundColor: "white", boxShadow: 3,
                        borderRadius: "8px", zIndex: 1000
                    }}>
                        <MenuItem onClick={() => navigate("/landingpagesubscription")}>Subscription </MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Paper>
                )}
            </AppBar>

            {/* Drawer for mobile */}
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                {DrawerContent}
            </Drawer>
        </>
    );
};

export default Cateringsnavbars;
